import { useState } from 'react'
import { SparklesIcon } from '@/Components/UI/Icons'

interface EventNameSectionProps {
  initialValue?: string
  savedValue?: string
  suggestedNames?: string[]
  loadingSuggestions?: boolean
  onChange: (value: string) => void
  hasError?: boolean
}

const EventNameSection = ({
  initialValue = '',
  savedValue,
  suggestedNames,
  loadingSuggestions,
  onChange,
  hasError,
}: EventNameSectionProps) => {
  const [eventName, setEventName] = useState(savedValue ?? '')

  const handleChange = (value: string) => {
    setEventName(value)
    onChange(value)
  }

  return (
    <div className='flex flex-col gap-6'>
      <p className='!font-semibold text-base sm:text-lg text-black leading-6'>
        Name your event: <span className='text-[#af231c]'>*</span>
      </p>
      <input
        type='text'
        value={eventName}
        onChange={({ target }) => handleChange(target.value)}
        maxLength={50}
        placeholder={initialValue ? `E.g. ${initialValue}` : 'Give your event a name...'}
        style={{ borderColor: hasError ? '#af231c' : '#BFBFBF' }}
        className={`w-full bg-white border rounded-[4px] px-[10px]
          py-2 text-sm sm:text-base text-[#1f1f1f] leading-6 outline-none
          focus:border-[#595959] transition-colors`}
      />
      {hasError && <p className='!text-[#af231c] text-sm'>Please enter a name.</p>}
      {loadingSuggestions && (
        <div className='flex flex-col gap-1'>
          <span className='!font-normal text-sm text-black leading-5 tracking-[0.07px]'>
            Suggested names:
          </span>
          <div className='flex flex-wrap gap-2'>
            {/* SKELETON RENDERING OF 3 - Change as needed */}
            {[1, 2, 3].map((i) => (
              <div key={i} className='h-8 w-32 rounded-full bg-[#f5f5f5] animate-pulse' />
            ))}
          </div>
        </div>
      )}
      {!loadingSuggestions && suggestedNames && suggestedNames.length > 0 && (
        <div className='flex flex-col gap-2'>
          <span className='!font-normal text-sm text-black leading-5 tracking-[0.07px]'>
            Suggested names:
          </span>
          <div className='flex flex-wrap gap-2'>
            {suggestedNames.map((name) => (
              <button
                key={name}
                type='button'
                onClick={() => handleChange(name)}
                className={`inline-flex items-center gap-1 border border-[#f5222d] rounded-full
                  px-3 py-1 cursor-pointer bg-transparent hover:bg-[#fff1f0]
                  transition-colors`}>
                <SparklesIcon />
                <span className='font-semibold text-sm sm:text-base text-[#1f1f1f] leading-6'>
                  {name}
                </span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default EventNameSection
